import React, { useEffect, useState } from "react";
import { Alert, Box, Typography } from "@mui/material";
import KeyboardOutlinedIcon from "@mui/icons-material/KeyboardOutlined";
import { useTranslation } from "react-i18next";
import {
  dismissAdvancedSearchShortcutHint,
  getAdvancedSearchShortcutLabel,
  isAdvancedSearchShortcutHintDismissed,
} from "../utils/advancedSearchShortcutHintStorage";

export default function AdvancedSearchShortcutHint({ open = false }) {
  const { t } = useTranslation("shell");
  const [visible, setVisible] = useState(false);
  const shortcut = getAdvancedSearchShortcutLabel();

  useEffect(() => {
    if (!open || isAdvancedSearchShortcutHintDismissed()) {
      setVisible(false);
      return;
    }
    setVisible(true);
  }, [open]);

  if (!visible) return null;

  const handleDismiss = () => {
    dismissAdvancedSearchShortcutHint();
    setVisible(false);
  };

  return (
    <Alert
      severity="info"
      icon={<KeyboardOutlinedIcon fontSize="inherit" />}
      onClose={handleDismiss}
      sx={{
        mx: 3,
        mt: 2,
        mb: 0,
        borderRadius: 1.5,
        py: 0.75,
        alignItems: "flex-start",
        flexShrink: 0,
        "& .MuiAlert-message": { width: "100%", py: 0.125 },
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1.35 }}>
        {t("search.advancedSearchShortcutHintTitle")}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.35, lineHeight: 1.45 }}>
        {t("search.advancedSearchShortcutHintBody", { shortcut })}
      </Typography>
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          mt: 0.75,
          px: 0.75,
          py: 0.2,
          borderRadius: 1,
          bgcolor: "action.hover",
          fontSize: "0.75rem",
          fontWeight: 600,
          letterSpacing: "0.02em",
          color: "text.secondary",
        }}
      >
        {shortcut}
      </Box>
    </Alert>
  );
}
